import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./style.css";
import { AdminBranchAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ModalDelete } from "./resources/modalDelete";
export var View = function (props) {
    return (_jsxs(_Fragment, { children: [_jsx(ModalDelete, { openModalConfirmDelete: props.openModalDelete, setOpenModalDelete: props.setOpenModalDelete, modalTitle: props.modalTitle, onClickDelete: props.onSubmit }), _jsx(AdminBranchAFY
            // Filter Props
            , { 
                // Filter Props
                showSelectStatus: true, showSelectBranch: true, showSelectRole: true, titleButtonClear: "Limpiar filtros", 
                // Drawer Props
                openDrawer: props.openDrawer, 
                // Admin Props
                title: props.title, buttonTextAdd: props.buttonTextAdd, buttonText: props.buttonText, columns: props.columns, rows: props.list, onClickAdd: props.onClickAdd, 
                // Form Props
                editMode: props.editMode, titleForm: props.titleForm, textDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, doloremque cumque ipsa ad reprehenderit animi similique, voluptas laborum dolore labore esse placeat natus molestiae accusantium molestias pariatur beatae dignissimos. ", onSaveData: props.onSaveData, widthLabelLinearForm: "400px", 
                //unkown props
                onBlurSearch: function noRefCheck() { }, onChangeData: props.filterStatus, onCloseSearch: props.onCloseSearch, onChangeSearch: props.searchFilter, onCloseDrawer: props.onCloseDrawer, dataForm: props.dataForm })] }));
};
